import styled from '@emotion/styled'
import { Box, Paper } from '@mui/material'
import React from 'react'
import { customStyles, spaceBetween } from '../../../styles'
import { CaptionText, RegularText, SmallText } from '../../helpers'
import { RatingStars } from './RatingStars'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { MiniMap } from './MiniMap'

export const InforOrder = () => {
    const CustomBox = styled(Box)(() => ({
        ...spaceBetween,
        // ...props
    }))
  return (
    <Paper sx={{  padding: 1 }}>
        <RegularText text="$600"/>
        <CustomBox>
            <SmallText text="Subtotal"/>
            <SmallText text="$500.00 MXN"/>
        </CustomBox>
        <CustomBox>
            <SmallText text="Cuota de servicio"/>
            <SmallText text="$50.00 MXN"/>
        </CustomBox>
        <CustomBox>
            <SmallText text="Tarifa dinámica *1.2X"/>
            <SmallText text="$50.00 MXN"/>
        </CustomBox>
        <SmallText text="14/07/2022 - 18:14"/>
        <CustomBox>
            <SmallText text="Calificación del servicio"/>
            <RatingStars rating={3.5}/>
        </CustomBox>
        <CustomBox>
            <CustomBox sx={{ width: '20%' }}>
                <LocationOnOutlinedIcon />
                <SmallText text="Casa"/>
            </CustomBox>
            <CaptionText text="Gomez de la calma #951 jardines del Eden Jalisco MX"/>
        </CustomBox>
        <MiniMap />
    </Paper>
  )
}
